import { render, staticRenderFns } from "./NavHeaderItems.vue?vue&type=template&id=38593432&scoped=true"
import script from "./NavHeaderItems.vue?vue&type=script&lang=js"
export * from "./NavHeaderItems.vue?vue&type=script&lang=js"
import style0 from "./NavHeaderItems.vue?vue&type=style&index=0&id=38593432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38593432",
  null
  
)

export default component.exports